import React from 'react'
import "./FinlandSection.css"
import reviewRating from '../../assets/images/review-rating.svg'
import nasadavisImage from '../../assets/images/nasadavis.jpeg'
import finlandFunImage from '../../assets/images/finland-fun.jpg'

const FinlandSection = () => {
  return (
<>
<div className="uk-section trip-background-moss uk-height-viewport top-z" uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-small; delay: 200; offset-top: 100; repeat: true;">
    <div className="uk-width-1-1">
        <div className="uk-container uk-container-large"> 

                <div className="uk-grid-colapse uk-grid-margin uk-grid" uk-grid=""  >

                    <div className="uk-width-1-2@m" uk-scrollspy-class="uk-animation-slide-bottom-medium">
                        <div className='trip-heading-display trip-ultra'>        
                        Meanwhile, 44 <br/>
                                of you went for <br/>
                                this one-of-a-kind moment: a reindeer sleigh ride in Finland.
                            </div>
                    </div>

                    <div className="uk-width-1-2@m" uk-scrollspy-class="uk-animation-slide-bottom-medium">

                        <div className='finishImageContainer uk-margin-auto uk-text-center'>
                                <img src={finlandFunImage} alt="people on trip" className="finish-people-image" />
                        </div>

                    </div>

                </div>

                <div className='bottom-finland-review' uk-scrollspy-class="uk-animation-slide-top-medium">

                <div className="">

                        <div className='uk-card uk-card-border location-review-container'>

                                <div className='reviewfull-rating'>
                                            <img src={reviewRating} alt="Star Rating" className=''/>
                                </div>

                                <div className='location-review-content'>
                                It was a lovely day to visit the cutest huskies, meet the reindeers and drive a snowmobile in the Lappish wilderness.

                                </div>

                                <div className="uk-flex uk-flex-middle location-review-user-info">
                                        <div className="uk-margin-small-left location-review-user">
                                            @nasadavis
                                        </div>
                                        <div className=" uk-flex-first">
                                            <img src={nasadavisImage} alt="User Avatar" className='location-avatar uk-border-circle'/>
                                        </div>
                                </div>
                                        



                                <div className='location-review-footer'>
                                Review of Snowmobile & Animals Day Tour
                                </div>

                        </div>

                </div>


                </div>

          
        </div>
    </div>
</div>




</>
  )
}

export default FinlandSection